var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.884916 9.75615H2.88468V17.9889C2.88468 18.1514 3.01639 18.2831 3.17893 18.2831H6.56961C6.73215 18.2831 6.86386 18.1514 6.86386 17.9889V9.79493H9.16276C9.31224 9.79493 9.438 9.68277 9.45507 9.53429L9.80422 6.50342C9.81381 6.42003 9.78739 6.33652 9.7316 6.27396C9.67575 6.21134 9.59584 6.17551 9.51198 6.17551H6.86398V4.2756C6.86398 3.70288 7.17235 3.41246 7.78062 3.41246C7.8673 3.41246 9.51198 3.41246 9.51198 3.41246C9.67452 3.41246 9.80622 3.28069 9.80622 3.11821V0.336152C9.80622 0.173609 9.67452 0.0419037 9.51198 0.0419037H7.12592C7.10909 0.0410798 7.07172 0.0397263 7.01663 0.0397263C6.60263 0.0397263 5.16358 0.120997 4.02684 1.16676C2.76734 2.32562 2.94242 3.71318 2.98426 3.95376V6.17545H0.884916C0.722373 6.17545 0.590668 6.30715 0.590668 6.46969V9.46184C0.590668 9.62439 0.722373 9.75615 0.884916 9.75615Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.71e37abadd2ef6ac2bd6349935afbed7.svg";
export { ForwardRef as ReactComponent };